import { useSuspenseQuery } from '@apollo/client/react';

import findByIdUserQuery from '~/shared/graphql-queries/users/find-by-id-user-query';

const getFindByIdUserQuery = ({ _id }: { _id: string }) => ({
  query: findByIdUserQuery,
  variables: { _id },
  notifyOnNetworkStatusChange: true,
});

export const useFindByIdUserQuery = ({ _id }: { _id: string }, options) => {
  const useQueryProps = useSuspenseQuery(findByIdUserQuery, {
    variables: { _id },
    notifyOnNetworkStatusChange: true,
    ...options,
  });
  const { loading, error, data, refetch } = useQueryProps;

  return {
    loading,
    error,
    refetch,
    data,
  };
};
